import type { LocationState } from "@types_def/common/path.types";

import { useLocation } from "react-router-dom";

export default function () {
  const location = useLocation();
  return location.state as LocationState;
}
